import { App, AppInstallation, Image } from '@tribeplatform/gql-client/types'
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'
import { PageHeader } from '@tribeplatform/react-ui-kit/PageHeader'

import { AppHeaderActions } from './AppHeaderActions'

export const AppHeader = ({
  app,
  appInstallation,
}: {
  app: App
  appInstallation: AppInstallation
}) => {
  return (
    <PageHeader
      title={app?.name}
      description={app?.description}
      avatar={
        app && (
          <Avatar
            size="2xl"
            src={(app?.image as Image)?.url}
            name={app?.name}
            rounded="md"
          />
        )
      }
      action={<AppHeaderActions app={app} appInstallation={appInstallation} />}
    />
  )
}
